import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Transition } from 'react-transition-group';
import { useHistory } from 'react-router-dom';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import orderBy from 'lodash/orderBy';
import { createStructuredSelector } from 'reselect';
import {
  Avatar,
} from '@pearsontechnology/aero-components';
import { toggleMobileSidebar } from 'containers/App/actions';
import { makeSelectMobileSidebarOpen } from 'containers/App/selectors';
import Sidebar, { SidebarOverlay } from 'components/Sidebar';
import NavHead from 'components/Navigation/NavHead';
import enhanceWithThemes from 'hocs/enhanceWithThemes';
import workspaceShape from 'Workspace/types/workspace';
import { selectWorkspacesList, selectWorkspace } from 'Workspace/Admin/store/selectors';
import workspaceService from 'services/WorkspaceService';
import themes from '../themes';
import {
  SidebarWrapper,
  LineBreakNewUX,
  Nav,
  NavWrapper,
  IconLeft,
} from './styles';

const WorkspaceSidebar = ({navigation: navItems, workspaces, toggleSidebar, mobileSidebarOpen, currentWorkspace, ...restProps}) =>{
  const [sortedWorkspace, setSortedWorkspace] = useState([]);
  const history = useHistory();
  //If selected workspace is available in store we will take from currentWorkspace, 
  //else we will get selected workspace from workspaceservice
  const selectedWorkspace = currentWorkspace || workspaceService.getSelectedWorkspace();
  const selectedWorkspaceId = (selectedWorkspace && selectedWorkspace.id) || '';

  const selectWorkspace = (workspace) => () => {
    workspaceService.updateWorkspace(workspace.id);
    if(!workspace.selected) {
      history.push('/courseware');
    }
  };

  useEffect(()=>{
    const handleKeydown = (event) => {
      if (event.code === 'Escape') {
        toggleSidebar(false);
      }
    }; 

    const sortWorkspace = () => {
      const sortedWorkspace = orderBy(workspaces, (workspace) =>
        `${workspace.name.trim().toLowerCase()}-${workspace.id}`, 'asc');
      setSortedWorkspace(sortedWorkspace);
    };

    sortWorkspace();
    document.addEventListener('keydown', handleKeydown);
    setTimeout(() => toggleSidebar(false));
    return ()=>{ document.removeEventListener('keydown', handleKeydown);};
  },[toggleSidebar, workspaces]);

  return(<Fragment>
    <Transition
      mountOnEnter
      unmountOnExit
      in={mobileSidebarOpen}
      onEnter={(node) => node && node.offsetHeight}
      timeout={400}
    >
      {(status) =>
        <SidebarOverlay status={status} onClick={() => toggleSidebar(false)} />
      }
    </Transition>
    
    <SidebarWrapper mobileSidebarOpen={mobileSidebarOpen}>
      <NavHead mobileSidebarOpen={mobileSidebarOpen} />
      <Sidebar newUX={true} data-testid='sideBar' mobileSidebarOpen={mobileSidebarOpen} {...restProps}>
        { navItems }
        <NavWrapper>
          <LineBreakNewUX />
          {
            sortedWorkspace && sortedWorkspace.map(({id, name}) => {
              const selected = id === selectedWorkspaceId;
              const displayInitials = `${(name[0] && name[0].toUpperCase()) || ''}${(name[1] && name[1].toLowerCase()) || ''}`;

              return (
                <Nav tabIndex="0" key={id} active={selected} onClick={selectWorkspace({id, name, selected})}>
                  {
                    <IconLeft active={selected}>
                      <Avatar avatar={{"givenName": name, "displayInitials": displayInitials}} size={30} />
                    </IconLeft>
                  }
                  { name }
                </Nav>
              );
            })
          }            
        </NavWrapper>
      </Sidebar>
    </SidebarWrapper>
  </Fragment>);
};

WorkspaceSidebar.propTypes = {
  navigation: PropTypes.element,
  workspaces: PropTypes.arrayOf(workspaceShape),
  toggleSidebar: PropTypes.func,
  mobileSidebarOpen: PropTypes.bool,
  currentWorkspace: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  workspaces: selectWorkspacesList,
  mobileSidebarOpen: makeSelectMobileSidebarOpen(),
  currentWorkspace: selectWorkspace,
});

const mapDispatchToProps = (dispatch) => ({
  toggleSidebar: (value) => dispatch(toggleMobileSidebar(value)),
});
  
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(enhanceWithThemes(WorkspaceSidebar,themes));